const translation = {
  "all_rights_reserved": "All Rights Reserved",
  "procedures": "Procedures",
  "laboratories": "Laboratories",
  "radiology": "Radiology",
  "consultation": "Consultation",
  "medical_consumables": "Medical Consumables",
  "medical_equipments": "Medical Equipment",
  "sanitation_disinfection": "Sanitation and Disinfection",
  "medical_equipment": "Medical Equipment",
  "procedure": "Procedure",
  "Disinfection": "Disinfection",
  "lab_supplies": "Lab Supplies",
  "pharmacy_items": "Pharmacy Items",
  "home": "Home",
  "dashboard": "Dashboard",
  "services": "Services",
  "products": "Products",
  "contact": "Contact",
  "login": "Login",
  "loginNow": "Login Now",
  "findMyDoctor": "Find My Doctor",
  "registerAsVendor": "Register as Vendor",
  "searchPlaceholder": "Search for products, services...",
  "welcomeMessage": "Welcome to Aryal Care",
  "currentLanguage": "Current language",
  "phone": "Phone",
  "email": "Email",
  "address": "Address",
  "website": "Website",
  "information": "Information",
  "aboutUs": "About us",
  "contactUs": "Contact Us",
  "privacyPolicy": "Privacy policy",
  "terms": "Terms and Conditions",
  "deliveryInfo": "Delivery info",
  "ordersReturns": "Orders returns",
  "customerCare": "Customer care",
  "help": "Help",
  "myAccount": "My account",
  "orderHistory": "Order history",
  "wishlist": "Wishlist",
  "newsletter": "News letter",
  "purchasingPolicy": "Purchasing policy",
  "newsletterText": "Sign up for our mailing list to get the latest updates and offers.",
  "enterEmail": "Enter your email address",
  "subscribeNow": "Subscribe now",
  "copyright": "copyright",
  "freeShipping": "Free shipping",
  "freeShippingText": "Free shipping world wide",
  "support24_7": "Support 24/7",
  "support24_7Text": "Contact us 24 hours a day",
  "securePayments": "Secure Payments",
  "securePaymentsText": "100% payment protection",
  "easyReturn": "Easy Return",
  "easyReturnText": "Simple returns policy",
  "title": "Categories",
  "scan": "Scan",
  "laboratory": "Laboratory",
  "miscellaneous": "Miscellaneous",
  "consumables": "Consumables",
  "pharmacy": "Pharmacy",
  "itemsFor": "Artículos de {category}",
  "categoryContent": "Contenido para la categoría {category} aparecería aquí.",
  "shopNow": "Shop Now",
  "yes": "Yes",
  "no": "No",
  "ok": "Ok",
  "cancel": "Cancel",
  "logout": "Logout",
  "logoutConfirmMessage": "Are you sure you want to logout?",
  "confirm": "Confirm",
  "step": "Step",
  "banners": {
    "title": "Banners",
    "web_banners": "Web Banners",
    "app_banners": "App Banners",
    "hero_banner": "Hero Banner",
    "hero_small_top": "Hero Small Top",
    "hero_small_bottom": "Hero Small Bottom",
    "deals_banner": "Deals Banner",
    "banner1": "Banner 1",
    "banner2": "Banner 2",
    "health_tip": "Health Tip",
    "hero_banner_bottom": "Hero Banner Bottom",
    "product_hero_banner": "Product Hero Banner",
    "middle_banner": "Middle Banner",
    "middle_small_banner": "Middle Small Banner",
    "lower_midline_banner": "Lower Midline Banner",
    "Hero Banner": "Hero Banner",
    "Hero Banner Top": "Hero Banner Top",
    "Health Tip": "Health Tip",
    "Hero Banner Product": "Hero Banner Product",
    "Primary banner": "Primary Banner",
    "Secondary Banner": "Secondary Banner",
    "Tertiary Banner": "Tertiary Banner",
    "Hero banner Top": "Hero Banner Top",
    "Health Banner": "Health Banner",
    "Hero Banner Bottom": "Hero Banner Bottom",
    "Product Banner": "Product Banner",
    "update": "Update",
    "ID": "ID",
    "Title": "Title",
    "Screen type": "Screen type",
    "Width": "Width",
    "Height": "Height",
    "Price": "Price",
    "noBannerData": "No banner data found.",
    "invalidImageFile": "Invalid image file.",
    "pleaseSelectImage": "Please select an image file.",
    "failedToUpdate": "Failed to update banner image.",
    "updateBannerImage": "Update Banner Image",
    "chooseNewImage": "Choose New Image",
    "requiredSize": "Required size: {{width}}x{{height}}px, Max {{maxSize}}MB",
    "uploading": "Uploading...",
    "updateImage": "Update Image",
    "chooseFile": "Choose File",
    "noFileChosen": "No file chosen",
    "updatedSuccessfully": "Banner updated successfully",
    "invalidDimensions": "Image dimensions must be {{width}}x{{height}}px"

  },
  "loginPage": {
    "subtitle": "Access your vendor dashboard to manage your healthcare services.",
    "username": "Username",
    "usernamePlaceholder": "Enter your username",
    "password": "Password",
    "passwordPlaceholder": "Enter your password",
    "forgotPassword": "Forgot password?",
    "loginButton": "Login",
    "loggingIn": "Logging in...",
    "loginFailed": "Login failed",
    "errorMessages": {
      "invalidCredentials": "Invalid username or password",
      "invalidUser": "Invalid user type. ",
      "serverError": "Server error, please try again later",
      "networkError": "Network error, please check your connection",
      "required": "Please fill out this field"
    }
  },

  "vendorRegistration": {
    "idCard": {
      "idcard_type": "ID Card Type",
      "idcard_no": "ID Card Number",
      "enter_number": "Enter ID card number",
      "cf_description": "Enter CF number (9 digits)",
      "cj_description": "Enter CJ number (10 digits)",
      "dimex_description": "Enter DIMEX number (11-12 digits)",
      "nite_description": "Enter NITE number (10 digits)",
      "pe_description": "Enter PE number",
      "cof_description": "Enter COF number",
      "dni_description": "Enter 8-digit DNI number",
      "ce_description": "Enter 12-digit CE number",
      "pas_description": "Enter passport number",
    },
    "title": "Vendor Registration",
    "headers": {
      "step1": "Register as Vendor",
      "step2": "Vendor Type",
      "step3": "Vendor Details",
      "step4": "Address",
      "step5": "Account Details",
      "step6": "Select the Subscription Plan",
      "step7": "Preview and Submit"
    },
    "descriptions": {
      "step1": "Complete the form below to register as a Vendor. We're excited to bring your expertise into our digital healthcare network.",
      "step2": "Ready to connect with clinics and hospitals digitally? Register now to showcase your services to the right audience.",
      "step3": "Provide details about your organization or medical practice.",
      "step4": "Tell us where your services operate from. We'll make sure the right connections find their way to you.",
      "step5": "Tell us where your services operate from. We'll make sure the right connections find their way to you.",
      "step6": "Terms and Information. By choosing a subscription, you agree to the service usage terms",
      "step7": "Review all information before submitting your registration."
    },
    "subdescriptions": {
      "step1": "Fill up the registration details.",
      "step2": "Please select which service you are interested in..",
      "step3": "Fill up the vendor details.",
      "step4": "Enter the vendor details below to complete your registration.",
      "step5": "Fill up the account details.",
      "step7": "Review all information before submitting your registration."
    },
    "formLabels": {
      "name": "Organization Name",
      "adminName": "Admin Name",
      "userName": "Username",
      "email": "Email",
      "phone": "Phone",
      "emergencyPhone": "Emergency Phone",
      "password": "Password",
      "confirmPassword": "Confirm Password",
      "vendorType": "Vendor Type",
      "otherProfessional": "Other Profession",
      "accreditation": "Accreditation",
      "regNumber": "Registration Number",
      "deliveryRadius": "Delivery Radius (km)",
      "website": "Website",
      "establishedYear": "Year Established",
      "gst": "GST",
      "vat": "VAT",
      "street": "Street",
      "city": "City",
      "country": "Country",
      "region": "State/Province",
      "zip": "ZIP Code",
      "accountName": "Account Holder Name",
      "bankName": "Bank Name",
      "iban": "IBAN",
      "nid": "Identification Number",
      "accountAddress": "bank Branch Address",
      "accountPhone": "Account Phone",
      "singleUser": "Single User"
    },
    "account": {
      "accountHolder": "Account Holder Name",
      "bankName": "Bank Name",
      "iban": "Account Number / IBAN",
      "swift": "SWIFT/BIC Code",
      "branchAddress": "Bank Branch Address",
      "paymentMethod": "Payment Method",
      "currency": "Currency",
      "uploadProof": "Upload Proof of Account",
      "uploadFile": "Upload file"
    },
    "common": {
      "selectOption": "Please Select",
      "submitted_successfully": "Registration submitted successfully"
    },

    "placeholders": {
      "name": "Enter organization name",
      "adminName": "Enter admin name",
      "userName": "Enter username",
      "email": "Enter email",
      "phone": "Enter phone number",
      "emergencyPhone": "Enter emergency phone",
      "password": "Enter password",
      "confirmPassword": "Confirm password",
      "accreditation": "Enter accreditation",
      "regNumber": "Enter registration number",
      "deliveryRadius": "Enter ius",
      "website": "Enter website URL",
      "establishedYear": "Enter year established",
      "gst": "Enter VAT",
      "street": "Enter street address",
      "city": "Enter city",
      "country": "Select country",
      "region": "Enter state/region",
      "zip": "Enter ZIP code",
      "accountName": "Enter account name",
      "bankName": "Enter bank name",
      "iban": "Enter IBAN",
      "nid": "Enter ID number",
      "accountAddress": "Enter account address",
      "accountPhone": "Enter account phone"
    },
    "errors": {
      "submissionFailed": "An unexpected error occurred. Please try again.",
      "idCardAlreadyExists": "ID card details already registered",
      "idCardStartsWithZero": "ID card number cannot start with 0",
      "invalidIdCardLength": "ID card number length is invalid",
      "invalidIdCardPattern": "ID card number format is invalid",
      "invalidIdCard": "Invalid ID card number",
      "idCardType": "Please select ID card type",
      "idCardNo": "Please enter a valid ID card number",
      "minLength": "Must be at least 3 characters long",
      "passwordComplexity": "Password should contain 8-30 characters, one lowercase and one uppercase letter, one number, and one special character",
      "required": "This field is required",
      "invalidEmail": "Invalid email",
      "passwordLength": "Password must be at least 8 characters",
      "passwordMismatch": "Passwords don't match",
      "invalidPhone": "Invalid phone number",
      "invalidWebsite": "Invalid website URL (include http:// or https://)",
      "invalidYear": "Enter a valid year (1800-current)",
      "invalidGST": "Invalid GST",
      "invalidZip": "Invalid ZIP code",
      "This name is already registered": "This name is already registered",
      "This phone is already registered": "This phone is already registered",
      "This email is already registered": "This email is already registered",
      "This accreditation is already registered": "This accreditation is already registered",
      "This reg_number is already registered": "This register number is already registered",
      "This user_name is already registered": "This user is already registered",
      "invalidFileType": "Only images (JPG/PNG/JPEG) and PDFs are allowed."
    },
    "buttons": {
      "previous": "Previous Step",
      "next": "Next Step",
      "submit": "Submit Registration",
      "goBack": "Go Back"
    },
    "success": {
      "title": "Registration Successful",
      "message": "Your vendor registration has been received and is under review. Our team will verify your details and approve your request shortly. You will be notified via email once your registration is approved."
    },
    "vendorTypes": {
      "hospital": "Hospital",
      "clinic": "Clinic",
      "laboratory": "Laboratory",
      "pharmacy": "Pharmacy",
      "diagnostic": "Diagnostic Center",
      "singleDoctor": "Single doctor",
      "singleNurse": "Single nurse",
      "other": "Other professionals"
    },
    "disclaimer": {
      "vatApplicable": "** 13% VAT is applicable on all paid plans"
    },
    "subscriptionTypes": {
      "Basic": "Basic",
      "Free": "Free Plan",
      "monthly": " Monthly",
      "yearly": " Yearly",
    },
    "selectProfession": "Select your profession",
    "selectProfessionPlaceholder": "Please Select"
  },
  // English translations
  "previewDetails": {
    "sections": {
      "registration": "Registration details",
      "vendorDetails": "Vendor type and details",
      "address": "Address",
      "transaction": "Transaction Details",
      "subscription": "Subscription"
    },
    "labels": {
      "close": "Close",
      "download": "Download",
      "idCardType": "ID card type",
      "idCardNumber": "ID card number",
      "notProvided": "Not Provided",
      "name": "Name",
      "email": "E-mail",
      "phone": "Phone Number",
      "emergencyPhone": "Emergency Number",
      "password": "Password",
      "vendorType": "Vendor Type",
      "accreditation": "Accreditation",
      "registerNumber": "Register Number",
      "deliveryRadius": "Delivery Radius",
      "website": "Website Link",
      "establishedYear": "Established Year",
      "gst": "GST",
      "vat": "VAT",
      "street": "Street Name",
      "city": "City",
      "country": "Country",
      "region": "Region",
      "zip": "Zip code",
      "accountHolder": "Account Holder Name",
      "bankName": "Bank Name",
      "accountNumber": "Account Number",
      "swiftCode": "SWIFT/BIC code",
      "branchAddress": "Branch Address",
      "paymentMethod": "Payment Method",
      "currency": "Currency",
      "proofDocument": "Proof document",
      "cannotPreviewFile": "This file type cannot be previewed."
    },
    "errors": {
      "popupBlocked": "Popup was blocked. Please allow popups for this site to view files."
    }
  },

  "registrationSuccess": {
    "title": "Registration Submitted Successfully",
    "successImageAlt": "Success icon",
    "message1": "Thank you for registering as a Vendor provider on our platform.",
    "message2": "Your registration has been received and is currently under review. Our backend team will verify your details and approve your request shortly. You will be notified via email once your registration is approved.",
    "message3": "If you have any urgent queries, feel free to contact our support team.",
    "returnButton": "Return Home"
  },
  "dashboardMenu": {
    "vendors": "Vendors",
    "catalogues": "Catalogues",
    "banners": "Banners",
    "revenue": "Revenue",
    "liabilities": "Liabilities",
    "vendorLiabilities": "Vendor Liabilities",
    "patientLiabilities": "Patient Liabilities"
  },
  "registeredHospitals": {
    "vendors": "Vendors",
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected",
    "searchClinic": "Search vendor",
    "searchID": "Search ID",
    "searchLocation": "Search location",
    "all": "All",
    "modernMedicine": "Modern Medicine",
    "ayurveda": "Ayurveda",
    "homeopathy": "Homeopathy",
    "unani": "Unani",
    "dental": "Dental",
    "multispeciality": "Multispeciality",
    "other": "Other",
    "id": "ID",
    "clinic": "Vendors",
    "patients": "Patients",
    "category": "Category",
    "type": "Vendor Type",
    "date": "Date",
    "location": "Location",
    "noMoreApproved": "No more approved list to show!!",
    "noMorePending": "No more pending list to show!!",
    "noMoreRejected": "No more rejected list to show!!",
    "noMoreExpired": "No more expired list to show!!"
  },
  "common": {
    "ok": "OK",
    "yes": "Yes",
    "no": "No",
    "notAvailable": "Not Available"
  },
  "hospitalDetails": {
    "navigation": {
      "home": "Home",
      "bankingInfo": "Banking Info",
      "reports": "Reports",
      "liabilities": "Liabilities"
    },
    "buttons": {
      "vendors": "Vendors",
      "clinics": "Clinics",
      "approve": "Approve",
      "reject": "Reject",
      "delete": "Delete",
      "activate": "Activate",
      "deactivate": "Deactivate"
    },
    "fields": {
      "id": "ID",
      "registrationNumber": "Registration Number",
      "vendorType": "Vendor Type",
      "username": "Username",
      "establishedYear": "Established Year",
      "email": "Email",
      "location": "Location",
      "phoneNumber": "Phone Number",
      "emergencyNumber": "Emergency Number",
      "website": "Website",
      "plan": "Subscription Plan",
    },
    "messages": {
      "approvedSuccessfully": "Approved Successfully",
      "deletedSuccessfully": "Deleted Successfully",
      "activatedSuccessfully": "Activated Successfully",
      "cannotDeleteDueToUnpaidBills": "Vendor cannot be deleted because there are unpaid bills",
      "deactivatedSuccessfully": "Deactivated Successfully",
      "rejectedSuccessfully": "Service Provider rejected Successfully",
      "failedToSubmit": "Failed to submit data",
      "failedToReject": "Failed to reject",
      "errorSubmission": "Error in Data Submission. Please try again!",
      "errorInData": "Error in Data",
      "providerDeleted": "This Provider Is Deleted"
    },
    "confirmations": {
      "delete": "Are you sure you want to delete this provider?",
      "activate": "Are you sure you want to activate this provider?",
      "deactivate": "Are you sure you want to deactivate this provider?",
      "areYouSure": "Are you sure?"
    },
    "id": "Vendor ID",
    "username": "Username",
    "registrationNumber": "Registration Number",
    "healthCareType": "Health Care Type",
    "vendorType": "Vendor Type",
    "establishedYear": "Established Year",
    "email": "Email",
    "location": "Location",
    "phoneNumber": "Phone Number",
    "emergencyNumber": "Emergency Number",
    "deliveryRadius": "Delivery Radius (km)",
    "website": "Website",
    "reject": "Reject",
    "approve": "Approve",
    "delete": "Delete",
    "deactivate": "Deactivate",
    "activate": "Activate",
    "areYouSure": "Are you sure to reject this service provider?",
    "approvedSuccessfully": "Approved successfully",
    "serviceProviderRejected": "Service Provider rejected Successfully",
    "failedToSubmit": "Failed to submit data",
    "failedToReject": "Failed to reject",
    "errorInData": "Error in Data Retrieval. Please try again!",
    "deleteConfirmation": "Are you sure to Delete this Service Provider?",
    "activateConfirmation": "Are you sure to Activate this Service Provider?",
    "deactivateConfirmation": "Are you sure to Deactivate this Service Provider?",
    "deletedSuccessfully": "Deleted successfully",
    "activatedSuccessfully": "Activated successfully",
    "deactivatedSuccessfully": "Deactivated successfully",
    "clinics": "Vendors",
    "home": "Home",
    "bankingInfo": "Banking Info",
    "reports": "Reports",
    "notAvailable": "Not Available",
    "thisProviderIsDeleted": "This service provider is deleted"
  },
  "professionals": {
    "general_practitioners": "General Practitioners",
    "therapists": "Therapists"
  },
  "paymentMethods": {
    "cash": "Cash",
    "bank": "Bank",
    "card": "Card",
    "cod": "Cod",
    "benefit_pay": "Benefit Pay",
    "upi": "UPI",
  },
  "currencies": {
    "eur": "EUR",
    "inr": "Inr",
    "usd": "USD",
    "crc": "CRC"
  },
  "professionalsList": {
    "Hospital": "Hospital",
    "Clinic": "Clinic",
    "Laboratory": "Laboratory",
    "Pharmacy": "Pharmacy",
    "Diagnostic Center": "Diagnostic Center",
    "Single Doctor": "Single doctor",
    "Single Nurse": "Single nurse",
    "General Practitioners": "General Practitioners",
    "Therapists": "Therapists",
    "Neurodevelopmental Specialists": "Neurodevelopmental Specialists",
    "Specialist Doctors": "Specialist Doctors",
    "Dentists": "Dentists",
    "Odontologists": "Odontologists",
    "Nurses": "Nurses",
    "Patient Assistants": "Patient Assistants",
    "Psychologists": "Psychologists",
    "Nutritionists": "Nutritionists",
    "Physiotherapists": "Physiotherapists",
    "Respiratory Therapists": "Respiratory Therapists",
    "Electrocardiography": "Electrocardiography",
    "Speech Therapists": "Speech Therapists"
  },
  "otpVerification": {
    "title": "Verify your details",
    "completeVerification": "Complete Verification",
    "bothMustVerify": "Both email and phone must be verified before proceeding",
    "emailVerification": "Email Verification",
    "phoneVerification": "Phone Verification",
    "verified": "Verified",
    "verifyEmail": "Verify Email",
    "verifyPhone": "Verify Phone",
    "enterOTP": "Enter OTP",
    "resendOTP": "Resend OTP",
    "sending": "Sending...",
    "verifying": "Verifying...",
    "submit": "Submit",
    "cancel": "Cancel",
    "proceedRegistration": "Proceed with Registration",
    "email": "Email",
    "phone": "Phone",
    "complete": "Complete",
    "successMessages": {
      "email": "Email verified successfully",
      "phone": "Phone verified successfully",
      "otpSent": "OTP sent to your {{method}}"
    },
    "errorMessages": {
      "invalidOTP": "Invalid OTP. Please try again.",
      "verificationFailed": "Verification failed. Please try again.",
      "sendFailed": "Failed to send OTP. Try again!",
      "enterOTP": "Please enter OTP",
      "verifyBoth": "Please verify both email and phone before proceeding"
    }
  },
  "bankingInfo": {
    "loading": "Loading...",
    "notProvided": "Not Provided",
    "accountNumber": "Account Number / IBAN",
    "swiftCode": "SWIFT/BIC Code",
    "branchAddress": "Branch Address",
    "paymentMethod": "Payment Method",
    "currency": "Currency",
    "proofDocument": "Proof Document",
    "subscriptionPlan": "Subscription Plan",
    "noBankInfo": "No bank informations found",
    "cash": "Cash",
    "bank": "Bank",
    "basic": "Basic",
    "free": "Free",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "title": "Banking Information",
    "accountHolder": "Account Holder",
    "bankName": "Bank Name",
    "errorLoading": "Error loading banking information",
    "close": "Close",
    "zoomIn": "Zoom In",
    "zoomOut": "Zoom Out",
    "resetZoom": "Reset Zoom",
    "cannotPreviewFile": "Cannot preview this file type",
    "clickToPreview": "Click to preview {{type}}: {{name}}",
    "standard": "Standard",
    "premium": "Premium",
    "failedToLoadPDF": "Failed to load PDF",
  },
  "serviceCatalogue": {
    "id": "Vendor ID",
    "searchByService": "Search by Service or Description",
    "searchByProduct": "Search by Product",
    "searchByVendorId": "Search by Vendor ID",
    "searchByVendorName": "Search by Vendor Name",
    "services": "Services",
    "createdAt": "Created At",
    "vendor": "Vendors",
    "duration": "Duration",
    "fee": "Fee",
    "serviceMode": "Service Mode",
    "home": "Home",
    "lab": "Clinic",
    "category": "Category",
    "subcategory": "Subcategory",
    "description": "Description",
    "shortDescription": "Short Description",
    "loading": "Loading..."
  },
  "revenue": {
    "title": "Revenue Analytics",
    "summaryTitle": "Revenue Summary",
    "totalRevenue": "Total Revenue",
    "totalTransactions": "Total Transactions",
    "activeVendors": "Active Vendors",
    "averageRevenue": "Average Revenue",
    "searchByVendorName": "Search by Vendor Name",
    "searchByVendorId": "Search by Vendor ID",
    "searchVendorsPlaceholder": "Search vendors by id or name...",
    "fromDate": "From Date",
    "toDate": "To Date",
    "export": "Export",
    "exportCSV": "Export CSV",
    "exportPDF": "Export PDF",
    "pieTitle": "Total Revenue Generated",
    "pieCenterTotal": "Total",
    "dataTitle": "Revenue Data",
    "allStatus": "All Status",
    "allTypes": "All Types",
    "id": "ID",
    "vendorName": "Vendor Name",
    "vendorType": "Vendor Type",
    "transactions": "Transactions",
    "lastTransaction": "Last Transaction",
    "actions": "Actions",
    "viewDetails": "View Details",
    "noData": "No revenue data found",
    "loading": "Loading...",
    "detailsTitle": "Revenue Details",
    "vendorId": "Vendor ID",
    "period": "Period",
    "timePeriod": "Time Period",
    "allTime": "All Time",
    "today": "Today",
    "thisWeek": "This Week",
    "thisMonth": "This Month",
    "thisYear": "This Year",
    "customRange": "Custom Range",
    "allVendors": "All Vendors",
    "vendorTypeMenu": "Vendor Type",
    "commissionDeducted": "Commission Deducted",
    "pendingAmount": "Pending Amount",
    "headers": {
      "hospitalId": "Vendor ID",
      "vendorName": "Vendor Name",
      "totalOrders": "Total Orders",
      "revenue": "Revenue",
      "commissionAmount": "Commission Amount",
      "commissionPercent": "Commission %",
      "commissionAmountPercent": "Commission Amount (%)",
      "netPayout": "Net Payout",
      "status": "Status",
      "type": "Type",
      "subscription": "Subscription",
      "period": "Period"
    },
    "vendorTypes": {
      "Hospital": "Hospital",
      "Clinic": "Clinic",
      "Laboratory": "Laboratory",
      "Pharmacy": "Pharmacy",
      "Diagnostic Center": "Diagnostic Center",
      "Therapists": "Therapists",
      "Neurodevelopmental Specialists": "Neurodevelopmental Specialists",
      "Dentists": "Dentists",
      "Odontologists": "Odontologists",
      "Patient Assistants": "Patient Assistants",
      "Psychologists": "Psychologists",
      "Nutritionists": "Nutritionists",
      "Physiotherapists": "Physiotherapists",
      "Respiratory Therapists": "Respiratory Therapists",
      "Electrocardiography": "Electrocardiography",
      "Speech Therapists": "Speech Therapists",
      "Single Doctor": "Single Doctor",
      "Single Nurse": "Single Nurse"
    },
    "searchVendorNamePlaceholder": "Search by vendor name...",
    "searchVendorIdPlaceholder": "Search by vendor ID...",
    "totalOrders": "Total Orders",
    "commissionReceived": "Commission Received",
  },
  "vendorDetails": {
    "noOrders": "No orders are present for the selected period",
    "filters": {
      "all": "All Orders",
      "products": "Products Only",
      "services": "Services Only",
      "fromDate": "From Date",
      "toDate": "To Date",
      "export": "Export",
      "exportCSV": "Export as CSV",
      "exportPDF": "Export as PDF"
    },
    "headers": {
      "itemName": "Item Name",
      "category": "Category",
      "quantity": "Quantity",
      "totalRevenue": "Total Revenue",
      "orderId": "Order ID",
      "invoice": "Invoice",
      "date": "Date"
    },
    "back": "Back",
    "viewInvoice": "View Invoice",
    "loading": "Loading...",
    "noItems": "No items found"
  },
  "liability": {
    "title": "Liabilities",
    "loading": "Loading...",
    "failedToLoad": "Failed to load liabilities",
    "noLiabilities": "No liabilities found.",
    "table": {
      "id": "ID",
      "item": "Item",
      "request": "Request",
      "paidAmount": "Paid amount",
      "totalAmount": "Total amount",
      "liability": "Liability"
    },
    "invoiceButton": "Invoice",
    "invoice": "Invoice",
    "openInvoice": "Open invoice",
    "noDownload": "No downloadable invoice available.",
    "email": "Email"
  },
  "invoice": {
    "title": "Invoice",
    "invoiceTitle": "INVOICE",
    "loading": {
      "loadingInvoice": "Loading invoice..."
    },
    "alerts": {
      "paymentRecorded": "Payment recorded successfully!",
      "failedToSave": "Failed to save payment. Please try again.",
      "enterTransactionRef": "Please enter transaction reference number",
      "identificationNotUpdated": "Identification number is not updated, so cannot proceed with the payment",
      "leadingSpacesNotAllowed": "Leading spaces are not allowed"
    },
    "buttons": {
      "print": "Print",
      "saveAndPay": "Save and Pay",
      "saving": "Saving..."
    },
    "labels": {
      "date": "Date",
      "itemService": "Item/Service",
      "issuedDate": "Issued Date",
      "total": "Total",
      "payable": "Payable",
      "transactionRef": "Transaction Reference Number *",
      "remarks": "Remarks"
    },
    "placeholders": {
      "transactionRef": "Enter transaction reference number",
      "remarks": "Enter any additional remarks"
    },
    "defaults": {
      "license": "License"
    },
    "notes": {
      "printWarning": "** If in case 'Print' does not work, please cross check if popup blocker is switched 'off' in your Browser settings.",
      "priceIncludesTax": "** Price is inclusive of all applicable taxes"
    }
  },
  "productCatalogue": {
    "headers": {
      "productName": "Product Name",
      "catalogueId": "Catalogue ID",
      "quantityInStock": "Quantity in Stock",
      "vendor": "Vendors",
      "vendorId": "Vendor ID",
      "createdAt": "Created At"

    }
  },
  "liabilities": {
    "loginAlegra": "Looks like your login session is invalid. Please log out and sign in again.",
    "title": "Vendor Liabilities",
    "loading": "Loading...",
    // "all": "All Liabilities",
    "all": "Liabilities",
    "paid": "Paid",
    "searchByName": "Search by name",
    "searchHospitalID": "Search by hospital ID",
    "hospitalID": "Hospital ID",
    "hospitalName": "Hospital Name",
    "billType": "Bill Type",
    "liability": "Liability",
    "billDate": "Bill Date",
    "renewalDate": "Renewal Date",
    "status": "Status",
    "noLiabilities": "No liabilities found",
    "noPaidLiabilities": "No paid liabilities found",
    "id": "ID",
    "invoice": "Invoice",
    "noInvoiceImage": "No invoice image available",
    "itemName": "Item Name",
    "vendor": "Vendor",
    "paidAmount": "Paid Amount",
    "searchID": "Search by ID",
    "statusValues": {
      "paid": "Paid",
      "not_paid": "Pending"
    }
  },
  "vendorRev": {
    "vendorId": "Vendor {{id}}",
    "invalidDate": "Invalid Date",
    "orderNumber": "Order Number",
    "name": "Name",
    "catalogueType": "Catalogue Type",
    "date": "Date",
    "product": "Product",
    "service": "Service",
    "orderDetails": "Order Details",
    "hospitalId": "Hospital ID",
    "invoice": "Invoice",
    "loading": "Loading...",
    "noOrders": "No orders found",
    "noInvoice": "No invoice available",
    "back": "Back",
    "filters": {
      "all": "All",
      "products": "Products",
      "services": "Services",
      "export": "Export",
      "exportCSV": "Export CSV",
      "exportPDF": "Export PDF",
      "fromDate": "From Date",
      "toDate": "To Date"
    }
  }
};
export default translation;
